import Layout  from '../../../components/layout'

const L = Layout
export default L